import Link from "next/link";
import { Icon } from "@zapier/zinnia-icons";
import { BetaDataTableCell as Cell, Text } from "@zapier/design-system";
import {
  AppTableInteractionEventOption,
  useEmitAppTableInteractionEvent,
} from "@zapier/shared";

import styles from "./CountCell.module.css";

interface Props {
  count?: number;
  showZapIcon?: boolean;
  href?: string;
}

const CountCell = ({ count = 0, showZapIcon, href }: Props) => {
  const countString = count.toLocaleString();

  const { emit } = useEmitAppTableInteractionEvent();

  const handleClick = () => {
    if (showZapIcon) {
      emit(AppTableInteractionEventOption.ViewZaps);
    }
    if (!showZapIcon) {
      emit(AppTableInteractionEventOption.ViewConnections);
    }
  };

  return (
    <Cell className={styles.cell}>
      {href ? (
        <Link href={href} className={styles.link} onClick={handleClick}>
          <span className={styles.root}>
            {showZapIcon && (
              <Icon color="TextWeakest" name="miscBoltAlt" size="16" />
            )}
            <Text type="Body1">{countString}</Text>
          </span>
        </Link>
      ) : (
        <span className={styles.root}>
          {showZapIcon && (
            <Icon color="TextWeakest" name="miscBoltAlt" size="16" />
          )}
          <Text type="Body1">{countString}</Text>
        </span>
      )}
    </Cell>
  );
};

export default CountCell;
